import { Injectable } from '@angular/core';
import { Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ConstantsService } from 'app/services/constants-service';
import { ObservableRequestService } from 'app/services/observable-request.service';

export interface TransactionProfileExportClient {
  clientId: number;
  clientName: string;
  entityId?: number;
  ruleCount: number;
  agreementCount: number;
}

export interface TransactionProfileExportStatus {
  status: string;
  message?: string;
  error?: string;
  progressPercentage?: number;
  clientCount?: number;
  ruleCount?: number;
  agreementCount?: number;
  fileName?: string;
  startTime?: number;
  endTime?: number;
  durationMs?: number;
  selectedClientIds?: number[];
}

@Injectable()
export class TransactionProfileExportService {

  constructor(private requestService: ObservableRequestService) {}

  getClientsWithProfiles(): Observable<TransactionProfileExportClient[]> {
    return this.requestService.getRequest(ConstantsService.TRANSACTION_PROFILE_EXPORT_CLIENTS_ENDPOINT)
      .map(response => response.arrResult as TransactionProfileExportClient[]);
  }

  startExport(clientIds?: number[]): Observable<any> {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    const body = clientIds && clientIds.length > 0 ? { clientIds: clientIds } : {};
    return this.requestService.postRequest(
      ConstantsService.TRANSACTION_PROFILE_EXPORT_START_ENDPOINT,
      body,
      headers
    ).map(response => response.arrResult);
  }

  getExportStatus(): Observable<TransactionProfileExportStatus> {
    return this.requestService.getRequest(ConstantsService.TRANSACTION_PROFILE_EXPORT_STATUS_ENDPOINT)
      .map(response => response.arrResult as TransactionProfileExportStatus);
  }

  downloadExport(): Observable<Blob> {
    return this.requestService.downloadFile(ConstantsService.TRANSACTION_PROFILE_EXPORT_DOWNLOAD_ENDPOINT);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/transaction-profile-export/transaction-profile-export.service.ts